<template>
    <div class="pa-3">
        <!-- dialog -->
		<v-dialog v-model="dialog" max-width="300">
			<v-form ref="form" @submit.prevent="submit" :disabled="submitLoading">
				<v-card>
					<v-card-title>
						<span class="me-n6">
							{{
								(!itemId ? $T('add') : $T('edit')) +
								' ' +
								'مهمة'
							}}
						</span>
						<v-spacer />
						<v-btn
							icon
							@click="dialog = false">
							<v-icon>$close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text class="pb-3">
						<v-row dense class="ma-0">
							<!-- name -->
							<v-col cols="12">
								<v-text-field
									v-model="name"
									:label="$T('inputs.name')"
									hide-details
									dense
									outlined
									:rules="[rules.required]"
								></v-text-field>
							</v-col>

                            <!-- percentage -->
							<v-col cols="12">
								<v-text-field
									v-model.number="percentage"
									:label="$T('inputs.percentage')"
									hide-details
									dense
									outlined
									:rules="[rules.required]"
                                    type="number"
                                    hide-spin-buttons
								></v-text-field>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions>
						<v-spacer />
						<v-btn
							color="secondary"
							type="submit"
							:loading="submitLoading"
						>{{ $T('save') }}</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>
        
        <!-- delete dialog -->
        <v-delete-dialog
			v-model="deleteDialog"
			:module="'addTaskType/delete'"
			:parameters="{ id: itemId !== null ? itemId : null }"
            @on-delete="getAll()">
			{{ $T('AddTaskType.delete-message') }}
		</v-delete-dialog>

        <v-row>
            <v-col cols="auto">
                <v-autocomplete
                    v-model="type"
                    :items="tasksType"
                    item-text="name"
                    item-value="id"
                    label="نوع المهمة "
                    outlined
                    dense
                    hide-details
                    clearable
                />
            </v-col>
            <v-spacer />
            <v-col cols="auto">
                <v-btn
                    @click="dialog = true"
                    small
                    dark
                    depressed
                    color="primary">
                    <v-icon left> $add </v-icon>
                    إضافة نوع مهمة 
                </v-btn>
            </v-col>
        </v-row>
        <bee-handy-table
            :headers="headers"
            :items="type ? tasksType.filter(c => c.id === type) : tasksType"
            :items-per-page="-1"
            hide-default-footer
            dense
            zebra
            :loading="loading"
            class="mt-2"
        >
            <template v-slot:item.actions="{ item }">
                <div class="d-flex justify-end">
                    <v-btn 
                        @click="itemId= item.id; dialog = true"  
                        icon
                        color="edit-color"
                    >
                        <v-icon left>$edit</v-icon>
                    </v-btn>
    
                    <v-btn 
                        @click="itemId= item.id; deleteDialog = true"  
                        icon
                        color="alert-color"
                    >
                        <v-icon left>$delete</v-icon>
                    </v-btn>
                </div>
            </template>
        </bee-handy-table>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import attendance from '../../../store/modules/attendance';
import validationRules from '@/utils/validation rules';

export default {
    name: 'add-permission-type',
    mixins: [attendance],
    watch: {
        dialog(val) {
            if(!val) {
                this.$refs.form.resetValidation()
                this.name = null
                this.percentage = null
                this.itemId = null
            } else {
                this.name = this.getById(this.itemId)?.name
                this.percentage = this.getById(this.itemId)?.percentage
            }
        }
    },
    data() {
        return {    
            type: null,
            loading: false,
            dialog: false,
            deleteDialog: false,
            submitLoading: false,
            name: null,
            percentage: 0,
            headers: [
				{
					text: 'الاسم',
					name: 'name',
					value: 'name',
				},
                {
					text: 'الاحتساب',
					name: 'percentage',
					value: 'percentage',
				},
				{
					text: '',
					name: 'actions',
					value: 'actions',
					noInput: true,
					sortable: false,
				},
			],
            itemId: null,
            rules: {
				...validationRules
            }
        }
    },

    computed: {
        ...mapState({
            tasksType: state => state.addTaskType.tasksType
        }),

        ...mapGetters({
            getById: 'addTaskType/getById'
        })
    },

    methods: {
        getAll() {
            this.loading = true
            return this.$store.dispatch('addTaskType/fetchAll').finally(() => {
                this.loading = false
            })
        },
        submit () {
            this.submitLoading = true
            const actionName = this.itemId ? 'update' : 'create'
            this.$store.dispatch(`addTaskType/${actionName}`, { 
                id: this.itemId ?  this.itemId : null,
                name: this.name, 
                percentage: this.percentage 
            }).then(() => {
                this.getAll()
            }).finally(() => {
                this.submitLoading = false
                this.dialog = false
            })
        }
    },

    created() {
        this.getAll()
    }
}
</script>
